import { InferType, boolean, number, object } from 'yup';
import { Nullable } from '../../../model/common';
import { safeString } from './common';

export const settingsSchema = object({
    general: object({
        timezone: object({ label: safeString().required(), value: safeString() }).required(
            'Timezone Settings is required.'
        ),
        idleTimeout: object({ label: safeString().required(), value: number() }).required('Idle Timeout is required.')
        // duration: object({ label: safeString().required(), value: number() }).required('Notification Duration is required.')
    }),
    notifications: object({
        show: object({ label: safeString().required(), value: boolean() }).required(
            'Notification Visibility is required.'
        )
        // duration: object({ label: safeString().required(), value: number() }).required('Notification Duration is required.')
    }),
    trading: object({
        tradingLayout: object({ label: safeString().required(), value: safeString().required() }).required(
            'Trading Layout is required.'
        ),
        twoClickTrading: object({ label: safeString().required(), value: boolean().required() }).required(
            'Two-Click Trading is required.'
        ),
        shortSellPrevention: object({ label: safeString().required(), value: boolean().required() }).required(
            'Short Sell Prevention is required.'
        ),
        defaultMarketOrderDuration: object({ label: safeString().required(), value: number().required() }).required(
            'Default Market Order Duration is required.'
        ),
        defaultLimitOrderDuration: object({ label: safeString().required(), value: number().required() }).required(
            'Default Limit Order Duration is required.'
        ),
        defaultStopOrderDuration: object({ label: safeString().required(), value: number().required() }).required(
            'Default Stop Order Duration is required.'
        )
    })
});

export type SettingsFormValues = InferType<typeof settingsSchema>;
export type SettingsFormInput = Nullable<SettingsFormValues>;
